import { REQUEST_NOTIFICATIONS_SUCCESS, REQUEST_NOTIFICATIONS_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { data: {}, errors: null };

export default function notifications(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case REQUEST_NOTIFICATIONS_SUCCESS:
     
      return { ...state, data: action.payload.data, errors: null }

    case REQUEST_NOTIFICATIONS_FAILURE:
     
      return { ...state, data: {}, errors: "list not returned" }
    default:
      return state;
  }
}